import React, {
  Fragment
} from 'react';

import PropTypes from 'prop-types';

import {
  HelpMeChooseUserCountOptions
} from 'src/Common/constants';

import {
  SalesContext
} from 'src/Context/SalesContext';

import WithPopup from 'src/HOC/WithPopup/WithPopup';

import {
  getRecommendations
} from 'src/Services/Services';

import {
  tagOnHelpMeChoosePlan,
  tagOnHowDoYouUse,
  tagOnHelpMeChooseHowMay
} from 'src/Tagging/SalesTagging';

import {
  isMobileView
} from 'src/Utility/utility';

import OptionTab from './HelpMeChoosePlanOptionTab/HelpMeChoosePlanOptionTab';

import './HelpMeChoosePlan.css';

export default class HelpMeChoosePlan extends React.Component {
  static propTypes = {
    close: PropTypes.func,
    defaultOptions: PropTypes.array,
    determinePackages: PropTypes.func
  };
  static contextType = SalesContext;

  state = {
    useType: {
      options: this.props.defaultOptions,
      valid: false,
      title: 'What do you use the internet for?',
      selectionOption: 'Please select your answers',
      questionNumber: 1
    },
    peopleType: {
      options: HelpMeChooseUserCountOptions,
      valid: false,
      title: 'How many people use the internet at your home?',
      selectionOption: 'Please select your answer',
      questionNumber: 2
    },
    currentPage: 'useType',
    numberOfQuestions: 2
  };

  componentDidMount() {
    tagOnHelpMeChoosePlan();
    tagOnHowDoYouUse();
  }

  onOptionSelectionChangedHandler = (id) => {
    const changedState = { ...this.state[this.state.currentPage] };
    const options = [ ...changedState.options ];
    const changedOption = options.find((e) => e.id === id);
    const changedOptionIndex = options.indexOf(changedOption);

    const selectedOpt = !changedOption.isSelected;

    if (this.state.currentPage === 'peopleType') {
      options.forEach((option) => (option.isSelected = false));
    }

    const newOption = { ...changedOption, isSelected: selectedOpt };
    options.splice(changedOptionIndex, 1, newOption);
    const isValid = options.some((e) => e.isSelected === true);
    this.setState({
      [this.state.currentPage]: {
        ...changedState,
        options: options,
        valid: isValid
      }
    });
  };

  getPossibleOptions = (userSelected) => {
    let ret = '';

    for (const select of userSelected) {
      ret += select.enterpriseType;
    }

    return `${ ret }People`;
  };

  getRecommendedOffers = async (internetUsage, peopleConnected) => {

    try {
      this.context.setShowSpinner(true);

      const res = await getRecommendations(internetUsage, peopleConnected);
      const speeds = res?.result?.downloadSpeeds || [];

      const validSpeeds = speeds.filter(speed =>
        this.context?.filters?.downloadSpeed.includes(speed)
      );

      if (validSpeeds.length <= 0) {
        this.context.setShowSpinner(false);

        return;
      }

      this.context.setShowSpinner(false);
      const currentFilters = this.context.filters;

      this.context.setFilters({
        ...currentFilters,
        selectedSpeeds: speeds
      });
    } catch (error) {
      console.error('Error fetching recommendations:');
      this.context.setShowSpinner(false);
    }
  };

  onNextButtonClickHandler = () => {
    switch (this.state.currentPage) {
    case 'useType':
      this.setState({ currentPage: 'peopleType' });
      tagOnHelpMeChooseHowMay();
      break;
    case 'peopleType':
      this.context.setShowSpinner(true);
      this.getRecommendedOffers(
        this.getPossibleOptions(
          this.state.useType.options.filter((e) => e.isSelected === true)
        ).concat(
          this.state.peopleType.options.find((e) => e.isSelected === true)
            .enterpriseTypeNumber
        ),
        this.state.peopleType.options.find((e) => e.isSelected === true)
          .peopleConnected,
        true
      );

      this.props.close();

      break;
    default:
      break;
    }
  };

  onBackButtonClickHandler = () => {
    switch (this.state.currentPage) {
    case 'peopleType':
      this.setState({ currentPage: 'useType' });
      break;
    case 'useType':
      this.props.close();
      break;
    default:
      break;
    }
  };

  render() {
    const contentStyleDesktop = {
      position: 'absolute',
      margin: 'auto',
      top: '50%',
      transform: 'translateY(-50%)',
      width: '100%'
    };

    const contentStyleMobile = {
      position: 'absolute',
      margin: 'auto',
      top: '0',
      width: '100%'
    };

    return (
      <WithPopup
        contentStyle={isMobileView() ? contentStyleMobile : contentStyleDesktop}
      >
        <div className="help-me-choose-plan-container">
          <div className="help-me-choose-plan-title-wrapper">
            <button
              onClick={this.props.close}
              className="help-me-choose-plan-close-button"
            >
              x
            </button>
            <div>
              <div className="help-me-choose-plan-steps">
                Question {this.state[this.state.currentPage].questionNumber} of{' '}
                {this.state.numberOfQuestions}
              </div>
              <div className="help-me-choose-plan-title">
                {this.state[this.state.currentPage].title}
              </div>
              <div className="help-me-choose-plan-content">
                {this.state[this.state.currentPage].selectionOption}
              </div>
            </div>
          </div>
          <div className="help-me-choose-plan-body">
            {this.state[this.state.currentPage].options.map((item, index) => (
              <OptionTab
                key={item.title}
                {...item}
                selected={this.onOptionSelectionChangedHandler}
                automationidattr={index}
              />
            ))}
          </div>
          <div className="help-me-choose-plan-footer">
            {!isMobileView() && (
              <hr className="help-me-choose-plan-footer-horizontal-line" />
            )}
            <div className="help-me-choose-plan-footer-btns">
              {isMobileView() ? (
                <Fragment>
                  <button
                    onClick={this.onNextButtonClickHandler}
                    disabled={!this.state[this.state.currentPage].valid}
                    className="help-me-choose-plan-next-button"
                  >
                    Next
                  </button>
                  {this.state.currentPage === 'useType' ? (
                    <button
                      onClick={this.onBackButtonClickHandler}
                      className="help-me-choose-plan-back-button"
                    >
                      Cancel
                    </button>
                  ) : (
                    <button
                      onClick={this.onBackButtonClickHandler}
                      className="help-me-choose-plan-back-button"
                    >
                      Back
                    </button>
                  )}
                </Fragment>
              ) : (
                <Fragment>
                  {this.state.currentPage === 'useType' ? (
                    <button
                      onClick={this.onBackButtonClickHandler}
                      className="help-me-choose-plan-back-button"
                    >
                      Cancel
                    </button>
                  ) : (
                    <button
                      onClick={this.onBackButtonClickHandler}
                      className="help-me-choose-plan-back-button"
                    >
                      Back
                    </button>
                  )}
                  <button
                    onClick={this.onNextButtonClickHandler}
                    disabled={!this.state[this.state.currentPage].valid}
                    className="help-me-choose-plan-next-button"
                  >
                    Next
                  </button>
                </Fragment>
              )}
            </div>
          </div>
        </div>
      </WithPopup>
    );
  }
}
